"use strict";
exports.__esModule = true;
function generateTenFiftyNinety(tenFiftyNinety, y) {
    if (y === void 0) { y = undefined; }
    if (y) {
        return [
            [tenFiftyNinety.ten, y.ten],
            [tenFiftyNinety.fifty, y.fifty],
            [tenFiftyNinety.ninety, y.ninety]
        ];
    }
    else {
        return [
            [tenFiftyNinety.ten, 0.1],
            [tenFiftyNinety.fifty, 0.5],
            [tenFiftyNinety.ninety, 0.9]
        ];
    }
}
function generateValuePointLegends(series) {
    var legendSeries = [];
    var legendIds = new Set(series.filter(function (data) { return (typeof data.linkedTo === "string" && data.linkedTo !== ':previous'); }).map(function (data) { return data.linkedTo; }));
    legendIds.forEach(function (id) {
        var matchedSeries = series.find(function (data) { return data.linkedTo === id; });
        legendSeries.push({
            type: 'scatter',
            id: id,
            name: id,
            color: matchedSeries.color,
            marker: matchedSeries.marker,
            data: []
        });
    });
    return legendSeries;
}
function formatNewDot(data, symbol, title, nodeName, color) {
    var marker = symbol === 'square' ? {
        symbol: symbol,
        radius: 5,
        lineColor: 'black',
        fillColor: color
    } : {
        symbol: symbol,
        lineColor: color,
        lineWidth: 4,
        states: {
            hover: {
                lineColor: color,
                lineWidth: 4
            }
        }
    };
    return {
        type: 'scatter',
        name: title + (" (" + nodeName + ")"),
        color: color,
        marker: marker,
        linkedTo: title,
        data: [data]
    };
}
function updateSeries(series, seriesData, settings, seriesKeyConfig, tagColor, zindex) {
    seriesData.forEach(function (rowData) {
        var seriesData = rowData[seriesKeyConfig.seriesDataKey];
        var CDF3Points = rowData[seriesKeyConfig.CDF3PointsKey];
        var PDF3Points = settings.showPDF ? rowData[seriesKeyConfig.PDF3PointsKey] : undefined;
        var tenFiftyNinety = generateTenFiftyNinety(CDF3Points, PDF3Points);
        if (tenFiftyNinety.length) {
            series.push({
                type: 'scatter',
                name: '10-50-90 Percentile (' + rowData.name + ')',
                color: tagColor,
                marker: {
                    radius: 5,
                    symbol: 'circle',
                    lineColor: 'black',
                    fillColor: tagColor
                },
                data: tenFiftyNinety
            });
        }
        if (seriesData.length) {
            series.push({
                name: settings.currentFit + (settings.showPDF ? ' PDF (' : ' CDF (') + rowData.name + ')',
                color: tagColor,
                zIndex: zindex,
                linkedTo: ':previous',
                data: seriesData
            });
        }
        if (settings.showPDF) {
            return;
        }
        var _a = rowData.rollUp3Points, base = _a.base, expected = _a.expected, submission = _a.submission;
        var rollUpCDFKey = settings.currentFit === 'Poland' ? 'polandCDF' : 'mcCDF';
        if (base.value) {
            var baseCaseData = [base.value, base[rollUpCDFKey]];
            var baseCaseSeries = formatNewDot(baseCaseData, 'square', 'Base Case Value', rowData.name, 'red');
            series.push(baseCaseSeries);
        }
        if (expected.value) {
            var expectedData = [expected.value, expected[rollUpCDFKey]];
            var expectedSeries = formatNewDot(expectedData, 'cross', 'Expected Value', rowData.name, 'red');
            series.push(expectedSeries);
        }
        if (submission.value) {
            var submissionData = [submission.value, submission[rollUpCDFKey]];
            var submissionSeries = formatNewDot(submissionData, 'diamond', 'submission Value', rowData.name, 'red');
            series.push(submissionSeries);
        }
    });
}
function generateSeries(dataRows, settings, legends, zindex) {
    if (zindex === void 0) { zindex = 6; }
    var fitKey = settings.currentFit === 'Poland' ? 'poland' : 'mc';
    var seriesKeyConfig = {
        seriesDataKey: fitKey + (settings.showPDF ? 'PDF' : 'CDF'),
        CDF3PointsKey: fitKey + 'CDF3Points',
        PDF3PointsKey: fitKey + 'PDF3Points'
    };
    var groupKeys = (dataRows || []).map(function (row) { return row.name; });
    var colorKeys = (legends || []).map(function (legend) { return legend.tag; });
    var groupColorMatch = groupKeys.every(function (key) { return colorKeys.includes(key); });
    var series = [];
    if (!groupColorMatch) {
        var tagColor = legends[0].color;
        updateSeries(series, dataRows, settings, seriesKeyConfig, tagColor, zindex);
    }
    else {
        var _loop_1 = function (legend) {
            var tagKey = legend.tag;
            var tagColor = legend.color;
            var seriesData = dataRows.filter(function (item) { return item.name === tagKey; });
            updateSeries(series, seriesData, settings, seriesKeyConfig, tagColor, zindex);
        };
        for (var _i = 0, legends_1 = legends; _i < legends_1.length; _i++) {
            var legend = legends_1[_i];
            _loop_1(legend);
        }
    }
    return series;
}
function getChartOptions(graph, options) {
    var currentNode = options.currentNode, _a = options.legends, legends = _a.legends, siblingLegends = _a.siblingLegends, settings = options.settings, timestamp = options.timestamp;
    var nodeName = currentNode.name;
    var chartTitle = (settings.showPDF ? 'Probability Density Function' : 'Cumulative Distribution Function')
        + ' - ' + (settings.currentFit) + ' Fit';
    var mainSeriesData = graph.main;
    var siblingSeriesData = graph.shadow || [];
    var series = generateSeries(mainSeriesData, settings, legends, 6);
    var xTitle = graph.Title + ' (' + graph.Units + ')';
    var yTitle = settings.showPDF ? 'PDF(y)' : 'Probability';
    if (siblingSeriesData.length > 0) {
        var siblingSeries = generateSeries(siblingSeriesData, settings, siblingLegends, 5);
        series = series.concat(siblingSeries);
    }
    if (!settings.showPDF) {
        series = series.concat(generateValuePointLegends(series));
    }
    return {
        chart: {
            type: 'spline',
            renderTo: 'chartContainer',
            height: 560,
            width: 650,
            zoomType: 'xy',
            marginRight: 50,
            inverted: false
        },
        credits: {
            text: timestamp,
            href: null
        },
        title: {
            text: chartTitle
        },
        xAxis: {
            // min: firstXValue > 0 ? 0 : undefined,
            reversed: false,
            title: {
                enabled: true,
                text: xTitle
            },
            // labels: {
            //     formatter: function () {
            //         return this.value;
            //     }
            // },
            maxPadding: 0.05,
            // showLastLabel: true,
            crosshair: true,
            plotLines: [{
                    color: '#ccd6eb',
                    width: 1,
                    value: 0
                }]
        },
        yAxis: {
            title: {
                enabled: true,
                text: yTitle
            },
            max: settings.showPDF ? undefined : 1,
            labels: {
                enabled: !settings.showPDF,
                formatter: function () {
                    return this.value * 100 + '%';
                }
            },
            lineWidth: 0,
            crosshair: true,
            plotLines: [{
                    value: 0,
                    color: 'black',
                    width: 2,
                    zIndex: 1
                }]
        },
        legend: {
            enabled: true,
            maxHeight: 150
        },
        tooltip: {
            enabled: settings.showTooltip,
            formatter: function () {
                return "<b>" + this.series.name + "</b> <br />" +
                    (xTitle + ": <b>" + this.point.x.toFixed(settings.decimals) + "</b><br />") +
                    (yTitle + ": <b>" + 100 * this.point.y.toFixed(settings.decimals) + "%</b>");
            },
            crosshairs: [true, true]
        },
        plotOptions: {
            series: {
                turboThreshold: 0
            },
            scatter: {
                marker: {
                    radius: 5,
                    symbol: 'circle',
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: 'rgb(100,100,100)'
                        }
                    }
                },
                states: {
                    hover: {
                        marker: {
                            enabled: false
                        }
                    }
                }
            }
        },
        series: series
    };
}
exports.getChartOptions = getChartOptions;
//# sourceMappingURL=portfolio-uncertainty2.chart.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/portfolio-uncertainty2/portfolio-uncertainty2.chart.js